import axios from 'axios';
import { ConfigTypes } from '../constants/configConstants';

const initialState = {
    lang: localStorage.getItem('config.lang') || 'en',
    jumpToTab: 0,
    viewChangeLog: false,
    tableId: "0",
};

window.config = {
    lang: localStorage.getItem('config.lang') || 'en'
};

axios.defaults.headers.common['accept-language'] = window.config.lang;

const persistLang = (lang) => {
    localStorage.setItem('config.lang', lang);
    window.config.lang = lang;
    axios.defaults.headers.common['accept-language'] = window.config.lang;
    return lang;
}

export const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case ConfigTypes.LANG_CHANGE:
            return {
                ...state,
                lang: persistLang(action.lang)
            };
        case ConfigTypes.JUMP_TO_TAB:
            return {
                ...state,
                jumpToTab: action.tab
            };
        case ConfigTypes.VIEW_CHANCELOG:
            return {
                ...state,
                viewChangeLog: action.view
            };
        case ConfigTypes.SET_TABLE_ID:
            return {
                ...state,
                tableId: action.tableId
            };

        case 'RESET':
            return {
                ...state,
                jumpToTab: 0
            };
        
        default:
            return state;
    }
};